import React, { useState, useEffect } from 'react'
import { axiosInstance } from '../utils';
import user from "../assets/imgs/user.jpeg";
import { useSelector } from 'react-redux';


const RecentActvCard = () => {

  const [recentAct, setRecentAct] = useState([]);

  const stateUser = useSelector((state) => state?.auth?.user);


  useEffect(() => {
    const token = localStorage?.getItem("token");
    axiosInstance.get("/api/admin/recent-activities", {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
       setRecentAct(res.data?.data);
    }).catch(err => console.log(err))
  
  }, [])


  return (
    <div className='md:w-full sm:w-full w-full lg:w-[670px] min-h-[370px] bg-white rounded-md py-8 px-6'>
    <div className='pb-2'>
        <h2 className='heading-two'>Recent activates:</h2>
    </div>

    <React.Fragment>
    {  stateUser?.auth === "ROLE_ADMIN" ? (
  <div className='flex flex-col gap-2'>
    { recentAct?.recentActivities?.map((result, index) => {
      return (

      
  <div className='flex lg:flex-row md:flex-row sm:flex-row flex-col gap-3 justify-between items-start md:items-center sm:items-center lg:items-center' key={index}>
      <div className='flex items-center gap-3'>
        {/* <div className='rounded-full w-10 h-10 bg-slate-800'></div> */}
        <div className='w-11 h-11'>
            <img src={user} alt="user" height={100} width={100} className="rounded-full !w-full !h-full" />
            </div>
        <p className='text-regular'>{result?.customerName}</p>
      </div>
      
      <p className={`flex justify-center items-center bg-primary-yellow-500 text-white text-regular w-[250px] h-6 rounded-xl px-3 py-3`}>{result?.description}</p>
    </div>
      )
    }) }
    
  </div>
    ) : (
      <div className='flex flex-col gap-2'>
        <div className='flex justify-between items-center'>
      <div className='flex items-center gap-3'>
        {/* <div className='rounded-full w-10 h-10 bg-slate-800'></div> */}
        <div className='w-11 h-11 '>
            <img src={user} alt="user" height={100} width={100} className="rounded-full !w-full !h-full" />
            </div>
        <p className='text-regular'>John Doe</p>
      </div>
      
      <p className={`flex justify-center items-center bg-primary-yellow-500 text-white text-regular max-w-min h-6 rounded-xl px-3 py-3`}>2g</p>
    </div>
      </div>
    ) }
    </React.Fragment>
</div>
  )
}

export default RecentActvCard